export { default } from "./AnnotationCardContents";
